module.exports = __webpack_public_path__ + "static/media/Fulfillrite.fb8b1c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Fulfillrite.png
// module id = 432
// module chunks = 0